var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('perfect-scrollbar',[_c('TopBar'),_c('div',{staticClass:"gol"},[_c('canvas',{attrs:{"id":"grid","width":_vm.width,"height":_vm.width,"n":_vm.n},on:{"dragover":_vm.dragOver,"drop":_vm.drop,"click":_vm.clickEv}})]),_c('Controls')],1)}
var staticRenderFns = []

export { render, staticRenderFns }